module.exports = __webpack_public_path__ + "img/post_box_letter.63483930.svg";